import RestUtility from '../../restUtility';
import { DoctorProfile } from '../types';
import {
  drProfileEndPoint,
  userEndPoint,
} from '../../restUtility/restEndpoints';
import { headerConfig } from '../utils/headerConfig';
import { notifyError } from 'config/setupBugsnag';

export class DoctorProfileService {
  private restUtility: RestUtility;

  constructor() {
    this.restUtility = new RestUtility();
    this.getDoctorProfile = this.getDoctorProfile.bind(this);
  }

  async getDoctorProfile() {
    const response = await this.restUtility.get<DoctorProfile>(
      drProfileEndPoint
    );
    this.updateDoctorProfileInfo(response);

    return this.transformDoctorProfileInfo(response);
  }

  async updateDoctorProfileInfo(profileInfo: DoctorProfile) {
    try {
      const response = await this.restUtility.post<{ success: boolean }>(
        `${userEndPoint}/update_ids_full_info`,
        { ids_full_info: profileInfo }
      );
      if (!response.success) {
        notifyError('Failed to update ids full info.', {});
      }
    } catch (error) {
      notifyError('ApiError:: updateDoctorProfileInfo', error);
    }
  }

  private transformDoctorProfileInfo(doctorProfileInfo: DoctorProfile) {
    return {
      ...doctorProfileInfo,
      tabs: this.buildDisplayData(
        { ...doctorProfileInfo.links, ...doctorProfileInfo.tabs },
        headerConfig.tabs
      ),
      links: this.buildDisplayData(
        { ...doctorProfileInfo.links, ...doctorProfileInfo.tabs },
        headerConfig.dropDown
      ).concat({
        link: '/logout',
        label: 'Logout',
      }),
    };
  }

  private buildDisplayData(apiData: Record<string, string>, config: string[]) {
    const displayData: Record<string, string>[] = [];
    config.forEach(tabName => {
      if (apiData[tabName]) {
        displayData.push({
          link: apiData[tabName],
          label: tabName,
        });
      }
    });
    return displayData;
  }
}
